import React from 'react';

const Services = () => {
  return (
    <div className="page">
      <div className="container">
        <h1>Our Services</h1>
        <p>Comprehensive marketing solutions tailored for restaurants.</p>
      </div>
    </div>
  );
};

export default Services;
